import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/zip.js
// module id = 224
// module chunks = 0 1 2 3 4